export const FILTERS = {
  PAYMENT_METHOD: 'paymentMethod',
  STATUS: 'status',
  VENDOR: 'vendorId',
  INVOICE_DATE: 'invoiceDate',
  PAYMENT_DATE: 'paymentDate',
  PAYMENT_DUE: 'paymentDue',
  APPROVAL_DATE: 'approvalDate',
  SOURCE: 'source',
  EXPORT_TO_ACCOUNTING: 'exportToAccounting',
  ACQUISITIONS_UNIT: 'acqUnitIds',
  TAGS: 'tags.tagList',
  BATCH_GROUP: 'batchGroupId',
  EXPENSE_CLASS: 'expenseClass',
  FUND_CODE: 'fundCode',
  LOCK_TOTAL: 'lockTotal',
  TOTAL_AMOUNT: 'total',
  FISCAL_YEAR: 'fiscalYearId',
  CREATED_BY: 'metadata.createdByUserId',
  DATE_CREATED: 'metadata.createdDate',
  DATE_UPDATED: 'metadata.updatedDate',
  UPDATED_BY: 'metadata.updatedByUserId',
  INVOICE_LINE_TAGS: 'invoiceLines.tags.tagList',
  INVOICE_LINE_CREATED_BY: 'invoiceLines.metadata.createdByUserId',
  INVOICE_LINE_DATE_CREATED: 'invoiceLines.metadata.createdDate',
  INVOICE_LINE_UPDATED_BY: 'invoiceLines.metadata.updatedByUserId',
  INVOICE_LINE_DATE_UPDATED: 'invoiceLines.metadata.updatedDate',
};
